<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>
        <h1 class="titulo mb-3">Acompanhamento de assinaturas de contrato</h1>
        <v-card class="v-card card-container">
            <v-card-text>
                <div>
                    <div id="tabs" class="container">
                        <div class="tabs">
                            <a @click="activetab=LISTAGEM" :class="{ active: activetab === LISTAGEM }">Listagem de Contratos</a>
                            <a @click="activetab=RASTREIO_ACOES" :class="{ active: activetab === RASTREIO_ACOES }">Rastreio de Ações do Contrato</a>
                            <a @click="activetab=LISTAGEM_RASCUNHO" :class="{ active: activetab === LISTAGEM_RASCUNHO }">Listagem de Rascunhos</a>
                        </div>

                        <div class="content">
                            <div v-if="activetab === LISTAGEM" class="tabcontent">
                                <FiltrosContratos :filter-data="filter_data" :id-carrinho="id_carrinho" :is-draft="false" @filter="controleFiltrosContratos" />

                                <div>
                                    <v-row>
                                        <v-col>
                                            <table class="legenda flex">
                                                <tr class="mb-5 ml-5">
                                                    <th style="font-size: 25px">Total de propostas: {{ total_contratos }}</th>
                                                </tr>
                                                <tr v-for="(dado, index) in legenda" :key="index" class="mt-5 ml-5 mb-2">
                                                    <th class="justify-end">
                                                        <v-icon color="accent">{{ mapIconStatus[legenda[index]] }}</v-icon>
                                                        Qtd propostas {{ legenda[index] }}: {{ dados[index] > 0 ? dados[index] : 0 }} ( {{ dados[index] > 0 ? parseInt((dados[index] * 100) / total_contratos) + '%' : 0 }} )
                                                    </th>
                                                    <th></th>
                                                </tr>
                                            </table>
                                        </v-col>
                                        <v-col>
                                            <Grafico v-if="dados.length > 0" :data="dados" :legenda="legenda" :dados="dados_grafico" />
                                            <p v-else>Carregando gráfico...</p>
                                        </v-col>
                                    </v-row>
                                </div>
                                <Listagem :key="activetab" @atualizaFiltroCarrinho="onAtualizaFiltroCarrinho" :filter="filter" :custom-filter="custom_filter" :id-documento="idDocumento" :somente-rascunho="false" />
                            </div>
                            <div v-if="activetab === RASTREIO_ACOES" class="tabcontent">
                                <v-form ref="form_rastreio">
                                    <v-row>
                                        <v-col cols="4">
                                            <m-text-field label="Nº da proposta:"
                                                          id="FieldPropostaRastreio"
                                                          class="required"
                                                          :rules="[$rules.required]"
                                                          maxlength="11"
                                                          v-model="filter_rastreio.id_documento"
                                                          item-text="id_documento"
                                                          item-value="id_documento"
                                                          outlined
                                                          v-input-filter="[$filters.numeric]"
                                            />
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select id="FieldStatusVenda"
                                                      label="Ações de rastreio: " outlined
                                                      :items="acoes_rastreio"
                                                      hide-details
                                                      v-model="filter_rastreio.acao_rastreio"
                                                      placeholder="Selecione a ação de rastreio"
                                                      item-text="name"
                                                      item-value="value" />
                                        </v-col>
                                    </v-row>
                                    <v-col class="mt-md-7">
                                        <v-row class="justify-md-space-between">
                                            <v-col cols="3" sm="3" class="mt-3 mt-sm-0">
                                                <v-btn color="secondary" block @click="limparFiltroRastreio">
                                                    Limpar
                                                </v-btn>
                                            </v-col>
                                            <v-col cols="3" sm="3" class="mt-3 mt-sm-0">
                                                <v-btn color="primary" @click="filtrarRastreio" block>
                                                    Gerar relatório
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-form>
                                <Rastreio :filter="filter_rastreio" />
                            </div>
                            <div v-if="activetab === LISTAGEM_RASCUNHO" class="tabcontent">
                                <Rascunhos :filter-data="filter_data" />
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

  import moment from 'moment'
  import Listagem from '@/views/painel/contratos/Listagem'
  import Grafico from '@/views/painel/contratos/Grafico'
  import Rastreio from '@/views/painel/contratos/Rastreio'

  import {
    TipoNegociacaoFuroDesc as TipoNegociacaoDesc,
    TipoNegociacaoFuro as TipoNegociacao,
    AcoesRastreio, origensAcesso, VALOR_FILTRO_TIPO_CONTRATO } from '@/plugins/constants'
  import { mapState } from 'vuex'
  import { notification } from '@/plugins/helpers'
  import { StatusAlocacoes, StatusAlocacoesDesc } from '../../../plugins/status_alocacoes'
  import { ListaAgrupamentosDeStatusContrato, TiposGrupoFiltro, TiposDePlano, TiposDeIndice } from '../../../plugins/constants'
  import FiltrosContratos from '@/components/contratos/FiltrosContratos.vue'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { DEFAULT_FILTER, DEFAULT_CUSTOM_FILTER } from '../../../enums/contratos/defaultFilters'
  import Rascunhos from '../../cadastro/contrato/Rascunhos.vue'

  export default {
    name: 'Contratos',
    components: { Grafico, Listagem, Rastreio, FiltrosContratos, Rascunhos },
    data: () => ({
      activetab: 'listagem',
      acoes_rastreio: [AcoesRastreio.compartilharDocumentos, AcoesRastreio.enviarContrato, AcoesRastreio.reenviarContratoEmail, AcoesRastreio.reenviarContratoWhatsapp, AcoesRastreio.visualizarDocumento, AcoesRastreio.liberarAssinatura],
      id_documento: '',
      id_carrinho: '',
      filter: {
        ...DEFAULT_FILTER
      },
      custom_filter: {
        ...DEFAULT_CUSTOM_FILTER
      },
      filter_rastreio: {
        id_documento: '',
        acao_rastreio: ''
      },
      // Esses filtros não usam o applyFilter no backend
      aba_filtro_rastreio_visivel: false,
      clientes: [],
      chartOptions: {
        hoverBorderWidth: 20
      },
      dados: [],
      legenda: Object.values(ListaAgrupamentosDeStatusContrato).map((value) => {
        return value
      }),
      mapIconStatus: {
        'Assinado': 'check',
        'Pendente': 'hourglass_empty',
        'Falha': 'error',
        'Negado': 'thumb_down',
        'Em Espera': 'work_off'
      },
      filter_data: {
        origensAcesso: Object.values(origensAcesso).map(value => {
          return { 'value': value }
        }),
        statusAlocacoes: Object.values(StatusAlocacoes).map(value => {
          return { 'value': value, 'label': StatusAlocacoesDesc[value] }
        }),
        origensContrato: Object.values(VALOR_FILTRO_TIPO_CONTRATO).map((value) => {
          return { ...value }
        }),
        opcoesSimNAO: [{ 'value': true, 'label': 'Sim' }, { 'value': false, 'label': 'Não' }],
        origensVenda: [],
        marcas: [],
        status_vendas: [],
        statusPagamento: [],
        formasPagamento: [
          { name: 'Cartão', value: 'cartao' }
        ],
        perfil_comercial: []
      },
      total_contratos: 0,
      propostas: [],
      dados_grafico: [],
      idDocumento: '',
      TiposGrupoFiltro,
      TiposDePlano,
      TiposDeIndice
    }),
    computed: {
      ...mapState([ 'empresas' ]),
      LISTAGEM: () => 'listagem',
      RASTREIO_ACOES: () => 'rastreio_acoes',
      LISTAGEM_RASCUNHO: () => 'listagem_rascunho',
      MAX_UNIDADES: () => 5,
      StatusContrato () {
        return Object.values(ListaAgrupamentosDeStatusContrato).map(value => ({ value: value, name: value }))
      },
      unidades () {
        const unidades = this.$session.get('unidades').map(unidade => ({ id_unidade: unidade.id_unidade_negocio, nome: unidade.nm_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio.toUpperCase()}` }))
        return unidades.sort(this.ordenar)
      },
      TipoNegociacaoFuro () {
        return Object.keys(TipoNegociacao).map(value => ({ value: TipoNegociacao[value], name: TipoNegociacaoDesc[TipoNegociacao[value]] }))
      }
    },
    async mounted () {
      try {
        await this.getFilterData()
        await this.getDadosGrafico()
      } catch (error) {
        notification(AlertTypes.ERROR, 'Erro ao carregar os dados: ' + error)
      }
    },
    methods: {
      onAtualizaFiltroCarrinho (id_carrinho) {
        this.id_carrinho = id_carrinho
      },
      validaDataInicial () {
        const format = 'YYYY-MM-DD'
        if (this.custom_filter.data_inicial.length === format.length && this.custom_filter.data_final.length === format.length) {
          const data_inicial = moment(this.custom_filter.data_inicial, format)
          const data_final = moment(this.custom_filter.data_final, format)

          if (data_final.isValid() && data_inicial.isAfter(data_final)) {
            return 'Data Inicial não pode ser maior que a Data Final!'
          }
        }

        return true
      },
      abrirFiltroRastreio () {
        this.aba_filtro_rastreio_visivel = true
      },
      atualizarGrafico () {
        this.dados = []
        this.getDadosGrafico()
      },
      controleFiltrosContratos (filters) {
        this.filter = filters.filter
        this.custom_filter = filters.custom_filter
        this.idDocumento = filters.id_documento
        this.id_documento = filters.id_documento
        this.atualizarGrafico()
      },
      async filtrarRastreio () {
        if (this.$refs.form_rastreio.validate()) {
          this.filter_rastreio = { ...this.filter_rastreio }
        }
      },
      async getFilterData () {
        const origensVendaPromise = this.getOrigensVenda()
        const marcasPromise = this.getMarcas()
        const statusVendaPromise = this.getStatusVenda()
        const formasPagamentoPromise = this.getFormasPagamento()
        const statusPagamentoPromise = this.getStatusPagamento()
        const perfisComerciaisPromise = this.getPerfiscomerciais()
        const indicesCorrecaoPromise = this.getIndicesCorrecao()
        return Promise.all([origensVendaPromise, marcasPromise, statusVendaPromise, formasPagamentoPromise, statusPagamentoPromise, perfisComerciaisPromise, indicesCorrecaoPromise])
      },
      async getFormasPagamento () {
        try {
          const response = await this.$http.get('/contrato/filtro/forma_pagamento')

          this.filter_data.formasPagamento = response.data.formasPagamento
        } catch (error) {
          notification('error', `Erro ao carregar o filtro formas de pagamento, erro:\n` + error)
        }
      },
      async getIndicesCorrecao () {
        try {
          const response = await this.$http.get('/contrato/filtro/indice_correcao')
          this.filter_data.indicesCorrecao = response.data.indicesCorrecao
        } catch (error) {
          notification(AlertTypes.ERROR, `Erro ao carregar o filtro tipo de índice erro:\n` + error)
        }
      },
      async getStatusPagamento () {
        try {
          const response = await this.$http.get('/contrato/filtro/status_pagamento')
          this.filter_data.statusPagamento = response.data.statusPagamento
        } catch (error) {
          notification('error', `Erro ao carregar o filtro status do pagamento, erro:\n` + error)
        }
      },
      async getOrigensVenda () {
        try {
          const response = await this.$http.get('/contrato/origens_venda')
          this.filter_data.origensVenda = response.data.origensVenda
        } catch (error) {
          notification('error', `Erro ao carregar o filtro origens de venda, erro:\n` + error)
        }
      },
      async getStatusVenda () {
        try {
          const response = await this.$http.get('/contrato/filtro/status_venda')
          this.filter_data.status_vendas = response.data.status_vendas
        } catch (error) {
          notification('error', `Erro ao carregar o filtro de status do pedido, erro:\n` + error)
        }
      },
      async getMarcas () {
        try {
          const response = await this.$http.get('/contrato/marcas')
          this.filter_data.marcas = response.data.marcas
        } catch (error) {
          notification('error', `Erro ao carregar o filtro de marcas, erro:\n` + error)
        }
      },
      async getPerfiscomerciais () {
        try {
          const response = await this.$http.get('/contrato/filtro/perfil_comercial')
          this.filter_data.perfil_comercial = response.data.perfil_comercial
        } catch (error) {
          notification('error', `Erro ao carregar o filtro de Hierarquia Comercial:\n` + error)
        }
      },
      limparFiltroRastreio () {
        this.$refs.form_rastreio.reset()
        this.filter_rastreio = {
          id_documento: '',
          acao_rastreio: ''
        }
        this.atualizarGrafico()
      },
      async getDadosGrafico () {
        const res = await this.$http.get('/painel/contrato/dados_grafico', { params: { filtros: this.filter, custom_filters: this.custom_filter, id_documento: this.id_documento } })
        this.dados_grafico = res.data

        this.legenda.forEach((len) => {
          let retornou_legenda = false
          res.data.forEach((dado) => {
            if (dado.status === len) {
              retornou_legenda = true
            }
          })
          if (!retornou_legenda) {
            res.data.push({ value: 0, status: len })
          }
        })

        const valores = res.data.map(item => item.value)
        const legenda = res.data.map(item => item.status)

        this.dados = valores
        this.legenda.forEach((len) => {
          if (!legenda.includes(len)) {
            legenda.push(len)
          }
        })

        this.legenda = legenda

        this.total_contratos = this.dados.reduce(function (total, numero) {
          return total + numero
        }, 0)

        return this.dados
      }
    }
  }
</script>

<style lang="scss" scoped>
@import url('../../../assets/css/tabs.css');

.mais-filtros {
    width: 100%;
    text-align: center;
}

.legenda {
    margin-top: 80px;
    display: grid;
    font-size: 20px;
}

</style>
